export enum PaymentTypes {
    BANK_TRANSFER_BSB = 'BANK_TRANSFER_BSB',
    PAY_ID_EMAIL = 'PAY_ID_EMAIL',
    PAY_ID_MOBILE = 'PAY_ID_MOBILE',
    SOUTH_KOREA_BANK_TRANSFER = 'SOUTH_KOREA_BANK_TRANSFER'
}
